<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card p-0 lg:min-h-[calc(100vh_-_theme('spacing.header')_*_1.4)] xl:min-h-[calc(100vh_-_theme('spacing.header')_*_1.6)]">
            <div class="flex flex-col gap-2 sm:flex-center-between sm:flex-row px-4 py-5 sm:p-7 bg-gray-200/30 dark:bg-dark-card-shade">
                <div>
                    <h6 class="card-title">Data Entry</h6>
                </div>
            </div>

            <div class="card p-2">
                <div class="flex flex-wrap items-center space-y-4 lg:space-y-0 lg:space-x-4">
                    <div class="w-full lg:w-auto">
                        <label for="orderDate" class="block text-sm font-medium text-gray-700">Order Date</label>
                        <input
                            type="month"
                            id="orderDate"
                            v-model="filter.orderDate"
                            class="w-full p-2 border border-gray-300 rounded"
                        />
                    </div>

                    <div class="w-full lg:w-auto flex justify-center lg:justify-start">
                        <button
                            type="button"
                            @click="getOrders"
                            class="btn btn-primary-solid px-5 mt-2 ml-4 mb-2 lg:mt-5 lg:ml-3 w-full lg:w-auto cursor-pointer"
                        >
                            Filter
                        </button>
                    </div>
                </div>
            </div>

            <div class="p-6 bg-gray-100 min-h-screen">
<div class="calendar-wrapper">

       <!-- Days Header -->
<div
    style="
        display:grid;
        grid-template-columns:repeat(7,minmax(0,1fr));
        gap:10px;
        margin-bottom:10px;
    "
>

    <div
        v-for="day in weekDays"
        :key="day"
        :class="day=='Wed'?'font-bold text-lg mb-2 text-danger ':'font-bold text-lg mb-2'"
    >
        {{ day }}
    </div>

</div>

<!-- Calendar Grid -->
        <div
    style="
        display:grid;
        grid-template-columns:repeat(7,minmax(0,1fr));
        gap:10px;
    "
>

    <div
        v-for="(date, index) in calendar"
        :key="index"
        class="border rounded p-2"
        :class="[
            date.isToday
                ? 'bg-green border-green-600'
                : date.data
                    ? 'bg-red border-red-400'
                    : 'bg-white'
        ]"
        style="min-height:140px;"
    >

        <!-- Day -->
        <div
            class="font-bold text-lg mb-2"
            :class="date.isToday ? 'text-green-800' : ''"
        >
            {{ date.day }}
        </div>

        <!-- Data -->
        <div
            v-if="date.data"
            class="space-y-1 text-sm"
        >

            <div class="bg-blue-100 rounded px-2 py-1">
                Full: {{ date.data.total_fullshirt }}
            </div>

            <div class="bg-green-100 rounded px-2 py-1">
                Half: {{ date.data.total_halfshirt }}
            </div>

            <div class="bg-yellow-100 rounded px-2 py-1">
                Pant: {{ date.data.total_pant }}
            </div>

        </div>

    </div>

</div>

    </div>
        </div>
    </div>
        </div>
    <!-- End Main Content -->
</template>
<style>
    .calendar-wrapper {
    width: 100%;
    overflow-x: auto;
}
.bg-green{
    background: aquamarine;
}
.bg-red{
    background:bisque;
}

</style>
<script>
import axios from 'axios';

export default {
    name: 'DelvCalender',
    mounted() {
        // this.getOrders();
    },
    data() {
        const today = new Date().toISOString().split('T')[0];

        return {
            orderList: [],
         
            filter: {
                orderDate: today,
            },
             
            selectedMonth: '',
            calendar: [],
            weekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            records: [],
        };
    },
    methods: {
      
        async getOrders() {

    var self = this;
        
            axios.post('getDeliveryCalender', this.filter)
                .then(function (response) {
        
                    self.records = response.data || [];
        
                    // sync selected month
                    self.selectedMonth = self.filter.orderDate;
        
                    // generate calendar
                    self.generateCalendar();
                })
                .catch(function (error) {
        
                    console.log('Error while loading orders: ' + error);
                });
        },
       generateCalendar() {

                const [year, month] = this.selectedMonth.split('-');
            
                const firstDay =
                    new Date(year, month - 1, 1).getDay();
            
                const daysInMonth =
                    new Date(year, month, 0).getDate();
            
                let calendar = [];
            
                // today's date
                const today = new Date().toISOString().split('T')[0];
            
                // blank cells
                for (let i = 0; i < firstDay; i++) {
            
                    calendar.push({
                        day: '',
                        data: null,
                        isToday: false
                    });
                }
            
                // month days
                for (let day = 1; day <= daysInMonth; day++) {
            
                    const currentDate =
                        `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            
                    const found = this.records.find(item =>
                        item.delivery_date === currentDate
                    );
            
                    calendar.push({
                        day: day,
                        data: found || null,
                        isToday: currentDate === today
                    });
                }
            
                this.calendar = calendar;
            }
    },
};
</script>
<style scoped>
    .qty_input{
        border: 1px solid black;
        width: 50px;
        padding: 4px;
        margin-right: 5px;
        border-radius: 3px;
    }
</style>